import { Component, Input } from '@angular/core';
import { ContentComponent } from '@shared/components/contents/content.component';
import { BlogArticle, Style, Widget, WidgetContent } from '@core/models';
import { Router } from '@angular/router';
import { ColorsEnum } from '@core/models/enums/colors.enum';

@Component({
  selector: 'shared-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.scss'],
})
export class ArticlesComponent implements ContentComponent {
  @Input() public widget: Widget;

  private defaultAlign: 'center' | 'flex-start' | 'flex-end' = 'flex-start';
  private defaultJustify: 'center' | 'flex-start' | 'flex-end' = 'center';
  private defaultColor: ColorsEnum = ColorsEnum.BLACK;
  private defaultBackgroundColor: string = 'transparent';
  private defaultPadding: string = '2rem';
  private defaultMargin: string = '0';

  public get contentWidget(): WidgetContent {
    return this.widget?.content;
  }

  public get articles(): BlogArticle[] {
    return this.contentWidget?.content as BlogArticle[];
  }

  public get contentStyle(): Style {
    return this.contentWidget?.style;
  }

  public get style(): { [key: string]: string } {
    return {
      alignItems: this.contentStyle.align || this.defaultAlign,
      justifyContent: this.contentStyle.justify || this.defaultJustify,
      color: this.contentStyle.color || this.defaultColor,
      backgroundColor: this.contentStyle.backgroundColor || this.defaultBackgroundColor,
      padding: this.contentStyle.padding || this.defaultPadding,
      margin: this.contentStyle.margin || this.defaultMargin,
    };
  }

  constructor(
    private readonly router: Router,
  ) {}

  public goToArticle(article: BlogArticle): void {
    this.router.navigate(['/blog', article.id]);
  }

  public trackById(idx: number, item: BlogArticle): string {
    return item.id;
  }
}
